// Ebbrest: кнопка Add у допродаж в выезжающей корзине (snippets/eb-cart-upsell.liquid). Сборщик D.
//
// Что делает: по нажатию кладёт один товар в корзину через Ajax Cart API (POST /cart/add.js) и тем же запросом
// просит у Shopify свежую разметку секций корзины (параметр sections). Перерисовывает корзину сама Horizon:
// скрипт отправляет её штатное событие shopify:cart:lines-update с обещанием, а cart-items-component, значок
// корзины и cart-drawer-component темы слушают его и обновляются. Так же поступает product-form.js темы.
//
// Чего не делает: сам в корзину ничего не кладёт (ни подарков, ни страховки доставки), запросы fetch темы
// не перехватывает и разметку корзины руками не трогает. Этим он отличается от lo-cart.js из Little Ounce:
// тот подменял window.fetch и переписывал innerHTML корзины, и заказ на нём не проходил.
//
// Ключей из .env не берёт. Адреса берёт из window.Theme.routes (snippets/scripts.liquid темы).
// Подключается один раз с defer: либо из snippets/eb-head.liquid, либо из snippets/cart-drawer.liquid
// (см. правки Horizon в README темы). Повторное подключение безвредно.
// Диагностика: ?eb_debug=1 в адресе пишет шаги в консоль.
//
// Не проверено (11.10.2026): на живой витрине не запускался и заказ через него не оформлялся.
// Проверены только разбор синтаксиса и логика на подставной странице (см. отчёт сборщика D).
(function () {
  'use strict';
  if (window.__ebCart) return;
  window.__ebCart = true;

  var DEBUG = /[?&]eb_debug=1/.test(location.search);
  var FALLBACK_ERROR = 'Could not add this item. Please try again.';

  function log() {
    if (!DEBUG || !window.console) return;
    console.log.apply(console, ['[eb-cart]'].concat([].slice.call(arguments)));
  }

  function routes() {
    var r = (window.Theme && window.Theme.routes) || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return {
      add: r.cart_add_url || root + 'cart/add.js',
      cart: r.cart_url || root + 'cart'
    };
  }

  // Секции корзины, которые есть на странице: у Horizon это cart-drawer-section, а на /cart ещё и секция страницы.
  function sectionIds() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }

  function request(url, body) {
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        log(body ? 'POST' : 'GET', url, response.status);
        // Отказ Ajax Cart API: статус 4xx и тело { status, message, description }.
        if (!response.ok || (data && data.status && data.message)) {
          var error = new Error((data && (data.description || data.message)) || FALLBACK_ERROR);
          error.ebCart = true;
          throw error;
        }
        return data;
      });
    });
  }

  // Модуль стандартных событий Shopify. Horizon объявляет его в importmap (snippets/scripts.liquid).
  // Грузим по требованию, один раз. Не загрузился: работаем без него (см. add).
  // Мина: Shopify при сжатии ассета переписывает import() в классическом скрипте на require(), и модуль
  // не грузится (проверено на стенде 12.10.2026). Поэтому модуль подключается вставкой <script type="module">.
  var eventsModule = null;
  function loadEvents() {
    if (eventsModule) return eventsModule;
    eventsModule = new Promise(function (resolve) {
      var done = false;
      function finish(mod) {
        if (done) return;
        done = true;
        resolve(mod && mod.CartLinesUpdateEvent ? mod : null);
      }
      try {
        window.__ebCartEvents = finish;
        var tag = document.createElement('script');
        tag.type = 'module';
        tag.textContent = "import * as m from '@shopify/events'; window.__ebCartEvents && window.__ebCartEvents(m);";
        tag.onerror = function () { finish(null); };
        document.head.appendChild(tag);
        setTimeout(function () { finish(null); }, 4000);
      } catch (e) {
        finish(null);
      }
    });
    return eventsModule;
  }

  function showError(root, text) {
    var box = root && root.querySelector('[data-eb-upsell-error]');
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
  }

  // После перерисовки корзины нажатая кнопка исчезает вместе со своей карточкой. Чтобы фокус не падал на body,
  // переводим его на следующую кнопку Add, а если её нет, на Checkout.
  function restoreFocus() {
    var active = document.activeElement;
    if (active && active !== document.body && active.isConnected) return;
    var dialog = document.querySelector('#cart-drawer dialog[open]');
    if (!dialog) return;
    var next = dialog.querySelector('[data-eb-upsell-add]') || dialog.querySelector('#checkout');
    if (next && next.focus) next.focus({ preventScroll: true });
  }

  function add(form) {
    var button = form.querySelector('[data-eb-upsell-add]');
    var input = form.querySelector('input[name="id"]');
    var variantId = input ? Number(input.value) : 0;
    if (!variantId || !button || button.getAttribute('aria-busy') === 'true') return;

    var root = form.closest('[data-eb-upsell]');
    var errorText = (root && root.getAttribute('data-eb-error-text')) || FALLBACK_ERROR;
    var r = routes();
    var ids = sectionIds();

    button.setAttribute('aria-busy', 'true');
    showError(root, '');

    function release() {
      // Кнопка могла уже уйти из разметки после перерисовки, тогда снимать нечего.
      if (button.isConnected) button.removeAttribute('aria-busy');
    }

    loadEvents().then(function (mod) {
      var deferred = null;
      if (mod) {
        deferred = mod.CartLinesUpdateEvent.createPromise();
        // Свой обработчик отказа, чтобы при ошибке браузер не писал unhandled rejection.
        deferred.promise.catch(function () {});
        form.dispatchEvent(new mod.CartLinesUpdateEvent({
          action: 'add',
          context: 'cart',
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          promise: deferred.promise
        }));
      }

      var body = { items: [{ id: variantId, quantity: 1 }] };
      if (ids.length) {
        body.sections = ids.join(',');
        body.sections_url = location.pathname;
      }

      return request(r.add, body).then(function (added) {
        if (!mod) {
          // Событий темы нет: показываем корзину обычной страницей, она отрисована сервером.
          log('no events module, opening the cart page');
          location.assign(r.cart);
          return;
        }
        return request(r.cart + '.js').then(function (cart) {
          log('added', variantId, 'sections', Object.keys(added.sections || {}));
          // Дальше Horizon подменяет разметку корзины. Нет разметки секции в ответе: тема запросит её сама.
          deferred.resolve({
            cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              sections: added.sections || undefined,
              items: cart.items,
              itemCount: cart.item_count,
              source: 'eb-cart-upsell',
              didError: false
            }
          });
          setTimeout(restoreFocus, 400);
        });
      }).catch(function (error) {
        log('failed', String(error));
        if (deferred) deferred.reject(error);
        showError(root, error && error.ebCart && error.message ? error.message : errorText);
      });
    }).then(release, release);
  }

  // Один слушатель на документ: корзину тема перерисовывает целиком, кнопки каждый раз новые.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-eb-upsell-form]')) return;
    // Нет fetch: форма уйдёт обычным способом, покупатель попадёт на страницу корзины.
    if (!window.fetch || !window.Promise) return;
    event.preventDefault();
    add(form);
  });

  // Ошибка купона в шторке (правка 14.10.2026 по проверке). Horizon показывает её снятием класса hidden под полем Discount,
  // а поле стоит в конце прокрутки над закреплённым итогом: строка ошибки оставалась под линией итога, 38-39 px ниже края.
  // Докручиваем только список шторки (scroll-hint), сам диалог не прокручивается. Логику купона не трогаем.
  function revealDiscountError(el) {
    var box = el.closest('scroll-hint.cart-drawer__content');
    if (!box) return;
    var r = el.getBoundingClientRect();
    var b = box.getBoundingClientRect();
    var pin = box.querySelector('.cart-drawer__summary');
    var bottom = pin ? Math.min(b.bottom, pin.getBoundingClientRect().top) : b.bottom;
    if (r.bottom > bottom - 4) box.scrollTop += r.bottom - bottom + 12;
    else if (r.top < b.top) box.scrollTop -= b.top - r.top + 12;
  }
  function watchDiscountErrors() {
    var root = document.getElementById('cart-drawer');
    if (!root || !window.MutationObserver) return;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.classList && t.classList.contains('cart-discount__error') && !t.classList.contains('hidden')) {
          requestAnimationFrame(function () { revealDiscountError(t); });
          return;
        }
      }
    }).observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  // Переход из допродажи в шторке на страницу товара (Choose, название, фото). От 990 px Horizon запоминает открытую
  // шторку в sessionStorage ('theme-drawer-open') и открывает её на следующей странице: страница товара, куда покупатель
  // пошёл выбирать вариант, открывалась со шторкой поверх колонки выбора. Для этих ссылок запомненное состояние снимаем.
  document.addEventListener('click', function (event) {
    var a = event.target && event.target.closest && event.target.closest('#cart-drawer .eb-upsell a[href]');
    if (!a) return;
    try { sessionStorage.removeItem('theme-drawer-open'); } catch (e) { /* без хранилища шторка и так не восстановится */ }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDiscountErrors);
  else watchDiscountErrors();
})();
